import React from 'react';
import './CareersBenefits.scss';
import Owl from '../../UI/Graphics/Owl';
import { COLORS } from '../../../constants/colors';
import Benefit from './Benefit/Benefit';

/**
 * Renders the careers benefits module
 * @param {string} title
 * @param {array} benefits
 * @returns {JSX.Element}
 * @constructor
 */
const CareersBenefits = ({ title, benefits }) => {
  return (
    <div className="c-careers-benefits">
      <div className="c-careers-benefits__inner">
        <div className="c-careers-benefits__header background-color-green">
          <div className="c-careers-benefits__header--inner">
            <div className="c-careers-benefits__title h1-roobert color-white">
              <h1>{title}</h1>
            </div>
            <div className="c-careers-benefits__owl-container">
              <Owl color={COLORS.white} />
            </div>
          </div>
        </div>
        <div className="c-careers-benefits__benefits background-color-gray">
          <div className="c-careers-benefits__benefits--inner">
            {benefits.map((benefit) => (
              <Benefit title={benefit.title} description={benefit.description} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareersBenefits;
